// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".y3-QHk_2XFHMQWiTBAhlT {\n    font-style: italic;\n}\n", ""]);
// Exports
exports.locals = {
	"missing": "y3-QHk_2XFHMQWiTBAhlT"
};
module.exports = exports;
